template
<template>
  <CustomPicker
    closeOnSelect
    inputLabel="انتخاب استاد مورد نظر"
    inputId="MasterPicker"
    title="fullName"
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :multiple="isMultiple"
    :items="usersList"
    v-model="selectedUser"
    @open="onOpen"
    @close="onClose"
    @search="handleSearch"
  >
    <template #no-options>هیچ استادی جهت نمایش وجود ندارد</template>
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">در حال لود...</li>
    </template>
  </CustomPicker>
</template>
<script>
import { GetAllUsersList } from "@/libs/Api/Users";
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  emits: ["getMaster"],
  props: {
    isMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultSelectedMaster: {
      type: Array | String | Number,
      required: false,
      default: null,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getAllUsers();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  watch: {
    selectedUser: {
      handler(val) {
        this.$emit("getMaster", val);
      },
    },
    defaultSelectedMaster: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedUser = this.defaultSelectedMaster;
        }
      },
    },
  },
  data() {
    return {
      isLoading: false,
      usersList: [],
      selectedUser: null,
      observer: null,
      pageNumber: 1,
      count: 30,
      totalCount: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        this.usersList = [];
        this.pageNumber = 1;
        await this.getAllUsers();
        loadingFn(false);
      }, 300);
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.pageNumber++;
          await this.getAllUsers();
        }
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          this.observer.observe(this.$refs.load);
        });
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    clearSelectedMaster() {
      this.selectedUser = null;
    },
    async getAllUsers() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUsersList = new GetAllUsersList(_this);
        getAllUsersList.setRequestParamDataObj({
          pageNumber: _this.pageNumber,
          count: _this.count,
          type: 3,
          fullname: _this.searchVal,
          // Type 3 is for masters
        });
        await getAllUsersList.fetch(
          function (response) {
            _this.usersList.push(...response.data.users);
            _this.totalCount = response.data.usersCount;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    hasNextPage() {
      if (this.totalCount && this.totalCount / this.count > this.pageNumber) {
        return true;
      }
      return false;
    },
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
</script>
